<template>
  <div
    class="occasion-tag">
    <div
      v-if="!isMobile"
      class="w-100">
      <div class="d-flex align-items-center">
        <img
          class="icon"
          :src="image">
        <div
          class="ms-3 name">
          <div>
            #{{ tag }}
            <br>
            <span class="small-text text-pewter no-text-transform">{{ looks }} looks</span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="w-100">
      <div
        class="d-flex justify-content-center">
        <img
          class="icon"
          :src="image">
      </div>
      <div
        class="d-flex justify-content-center mt-2">
        <div
          class="small-text text-pewter no-text-transform">
          {{ looks }} looks
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    tag: {
      type: String,
      required: true
    },
    looks: {
      type: Number,
      required: true
    },
    image: {
      type: String,
      required: true
    }
  },
  methods: {
    getIconImage (imageName) {
      return `${import.meta.env.VITE_WEBSITE_IMAGES_URL}system-tags/${imageName}`
    }
  }
}
</script>

<style lang="scss" scoped>

.no-text-transform {
  text-transform: none;
}

.occasion-tag {
  height: 84px;
  width: 100%;
  padding: 0 20px;
  //color: $plum;
  background-color: $white;
  font-weight: $font-weight-semibold;
  text-transform: capitalize;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (min-width: 576px) {
    height: 94px;
  }

  .name {
    width: calc(100% - 100px);
  }

  .icon {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    object-fit: cover;
    object-position: top;

    @media (min-width: 576px) {
      height: 64px;
      width: 64px;
    }

  }
}

</style>
